<template>
  <div>
    <div class="row mt-0">
      <div class="col-12 col-md-6 col-lg-3">
        <atom-multi-select
          v-model="ticketManagementFilter.type"
          title="Type"
          placeholder="All Type"
          label="name"
          :option="ticketManagementTypeOption"
        ></atom-multi-select>
      </div>
      <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
        <atom-select
          v-model="ticketManagementFilter.status"
          title="Status"
          placeholder="All Status"
          label="name"
          :option="ticketManagementStatusOption"
        ></atom-select>
      </div>
      <div class="col-12 col-lg-5 mt-1 mt-lg-0">
        <atom-select
          v-model="ticketManagementFilter.priority"
          title="Priority"
          placeholder="All Priority"
          label="name"
          :option="ticketManagementPriorityOption"
        ></atom-select>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 col-md-6 col-lg-3">
        <atom-input
          v-model="ticketManagementFilter.idcId"
          :title="contractIdLabel"
          :placeholder="contractIdLabel"
          type="number"
          :maxLength="8"
        ></atom-input>
      </div>
      <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
        <atom-select
          v-model="ticketManagementFilter.department"
          title="Department"
          placeholder="All Department"
          label="name"
          :option="ticketManagementDepartmentOption"
        ></atom-select>
      </div>
      <div class="col-12 col-md-6 col-lg-5 mt-1 mt-md-0">
        <atom-select
          v-model="ticketManagementFilter.createdBy"
          title="Created By"
          placeholder="All"
          label="name"
          :option="ticketManagementCreatedByOption"
        ></atom-select>
      </div>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixins from "@/mixins"

export default {
  name: "MoleculeReportFilterTicket",
  components: { AtomSelect, AtomMultiSelect, AtomInput },
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      required: true,
    },
    ticketManagementTypeOption: {
      type: Array,
      required: true,
    },
    ticketManagementStatusOption: {
      type: Array,
      required: true,
    },
    ticketManagementPriorityOption: {
      type: Array,
      required: true,
    },
    ticketManagementDepartmentOption: {
      type: Array,
      required: true,
    },
    ticketManagementCreatedByOption:{
      type: Array,
      required: true,
    }
  },

  computed: {
    ticketManagementFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
